module.exports = __webpack_public_path__ + "img/illu-data-security.5f1850a6.svg";